import ReactJson from "react-json-view";
import "./styles/PromineoJsonViewer.css";

interface Props {
  src: object;
}

export default function PromineoJsonViewer(props: Props) {
  return (
    <div className="promineo-josn-viewer">
      <ReactJson
        name={false}
        src={props.src}
        enableClipboard={false}
        displayObjectSize={false}
        displayDataTypes={false}
      />
    </div>
  );
}
